<template>
  <ModalActionConfirmation
    ref="modalConfirmDeleteInvite"
    title="Confirmação de exclusão"
    message="Atenção! Este convite será excluído permanentemente. Tem certeza de que deseja excluir?"
    @confirmed="deleteInvite"
  />
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ModalActionConfirmation from '@/components/Shared/ModalActionConfirmation.vue'

import RsvpApi from '@/lib/api/Rsvp'

export default {
  props: {
    rsvp: {
      type: Object,
    },
  },

  components: {
    ModalActionConfirmation,
  },

  computed: {
    ...mapGetters({
      logonToken: 'app/logonToken',
      rsvps: 'getRsvps',
    }),
  },

  methods: {
    ...mapActions({
      notification: 'app/setNotification',
      setRsvps: 'setRsvps',
    }),

    open() {
      this.$refs.modalConfirmDeleteInvite.open()
    },

    deleteInvite() {
      const api = new RsvpApi(this.logonToken)
      api
        .deleteRsvp(this.rsvp.id)
        .then(() => {
          this.setRsvps(this.rsvps.filter((rsvp) => rsvp.id !== this.rsvp.id))
          this.notification({
            message: 'Convite excluído com sucesso!',
            show: true,
          })
        })
        .catch(() => {
          this.notification({
            message: 'Erro ao excluir. Por favor, tente novamente.',
            show: true,
            timeout: 3000,
            class: 'is-error ',
          })
        })
    },
  },
}
</script>

<style lang="scss" scoped></style>
